/** True when HTML (or legacy plain text) has real answer content. */
export const hasAnswerContent = (html: string | null | undefined): boolean => {
  const value = (html || "").trim()
  if (!value) return false
  if (/<(img|table|svg|video|canvas)\b/i.test(value)) return true
  if (/data-type=["'](inline-math|block-math|diagram)["']/i.test(value)) {
    return true
  }
  if (/\bdata-latex=/i.test(value)) return true
  return Boolean(answerPlainSnippet(html))
}

/** Strip tags for compact previews of student answers. */
export const answerPlainSnippet = (html: string | null | undefined): string => {
  if (!html) return ""
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim()
}

export const answerStatusFromHtml = (
  html: string | null | undefined
): "answered" | "unanswered" =>
  hasAnswerContent(html) ? "answered" : "unanswered"
